import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../utils/utils';

const Ratio = styled.div`
    margin-bottom: 12px;
    display: flex;
    align-items: start;
    position: relative;

    small {
        display: block;
        margin-top: 4px;
        color: ${colors.gray.basic};
    }

    [type='radio'] {
        z-index: 0;
        -webkit-appearance: none;
        display: none;
    }
    [type='radio'] + label {
        font-weight: 400;
        word-break: break-word;
        padding-left: 28px;
    }
    [type='radio'] + label::before {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin-left: -28px;
        border: 2px solid ${colors.gray.basic};
        background-color: #fff;
        display: block;
        content: '';
        float: left;
        z-index: 5;
        position: relative;
    }
    [type='radio']:checked + label::before {
        box-shadow: inset 0 0 0 3px #fff;
        background: ${colors.gray.basic};
    }
`;

interface SelectorOption {
    key: string;
    value: React.ReactNode;
}

interface RadioButtonsProps {
    selectorValues?: SelectorOption[];
    selected?: string;
    onChange?: (value: string) => void;
}

function RadioButtons({ selectorValues = [], selected = '', onChange = () => undefined }: RadioButtonsProps) {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        if (value) {
            onChange(value);
        }
    };

    return (
        <div role="radiogroup">
            {selectorValues.filter(Boolean).map((element: SelectorOption) => {
                const id = `radio_${element.key}`;
                return (
                    <Ratio key={element.key}>
                        <input
                            type="radio"
                            id={id}
                            name="radio-group"
                            value={element.key}
                            checked={element.key === selected}
                            onChange={handleChange}
                        />
                        <label htmlFor={id}>{element.value}</label>
                    </Ratio>
                );
            })}
        </div>
    );
}

RadioButtons.defaultProps = {
    selectorValues: undefined,
    selected: undefined,
    onChange: undefined
};

export default RadioButtons;
